import { render, staticRenderFns } from "./cadprovedorescustos.vue?vue&type=template&id=506814b9&"
import script from "./cadprovedorescustos.vue?vue&type=script&lang=js&"
export * from "./cadprovedorescustos.vue?vue&type=script&lang=js&"
import style0 from "./cadprovedorescustos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports